<template lang="pug" src="./html/COPPSusMakeover.pug"></template>

<script>

  import Vue from 'vue'
  import PortfolioItemBase from './PortfolioItemBase'

  const COPPSusMakeoverBody = () => import(/* webpackChunkName: "copp-sus-makeover" */ './COPPSusMakeover-Body')

  Vue.component('COPPSusMakeoverBody', COPPSusMakeoverBody)

  export default {
    extends: PortfolioItemBase,
    mounted () {
      this.setBody('COPPSusMakeoverBody')
    }
  }
</script>

<style lang="sass" src="./style/PortfolioItem.sass"></style>

<style scoped>
    .portfolio-item {
        background-color: #5A7B2E;
    }
    .portfolio-item, a {
        color: #F4FAED;
    }
    .portfolio-item .logo {
        padding-top: 1em;
        height: 7em;
    }
    h1 {
        color: #FFFFFF;
    }
    .label, h2 {
        color: #A9CE56;
    }
</style>

<style>
    #app.copp-susmakeover #top-header {
        background-color: #558729;
    }
</style>
